export const stripTags = (val: string) => val.replace(/<\/?[^>]+(>|$)/g, '');
